import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FirestoreService } from 'src/app/services/firestore.service';

import * as firebase from 'firebase/app';


@Component({
  selector: 'app-tourpackage-detail',
  templateUrl: './tourpackage-detail.component.html',
  styleUrls: ['./tourpackage-detail.component.sass']
})
export class TourpackageDetailComponent implements OnInit {
  touroperatorDocId;
  touroperatorDoc;

  tourpackageDocId;
  tourpackageDoc;
  pictureCol;

  itineraryCol;
  
  coverPhoto: string = "./assets/img/no-cover.png";
  profilePhoto: string = "./assets/img/no-logo.png";
  //email: string = 'moses@pngl.com';

  logoImage: string = "./assets/img/no-logo.png";
  coverImage: string = "./assets/img/no-cover.png";

  constructor(
    public db: FirestoreService,
    public route: Router,
    public aroute: ActivatedRoute
    ) {}

  ngOnInit(): void {
    this.tourpackageDocId = this.aroute.snapshot.paramMap.get('id');
    this.tourpackageDoc = this.db.getTourPackageDoc(this.tourpackageDocId); 
    this.pictureCol = this.db.getSubCol('tourpackages', this.tourpackageDocId, 'tourPictures');

    this.db.getDocId('tourpackages', this.tourpackageDocId)
    .then(data=>{
      this.touroperatorDocId = data.touroperatorDocId;
      //this.touroperatorDoc = this.db.getMainDoc('touroperators', this.touroperatorDocId);
      console.log(this.touroperatorDocId);
    })
    this.itineraryCol = this.db.getSubColOrder('tourpackages', this.tourpackageDocId, 'itineraries', 'day');  
    this.scrollToTop()
  }

  scrollToTop(){
    this.route.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0)
    });  
  }
  
  reloadComponent() {
    let currentUrl = this.route.url;
    this.route.routeReuseStrategy.shouldReuseRoute = () => false;
    this.route.onSameUrlNavigation = 'reload';
    this.route.navigate([currentUrl]);
  }

  routeToDetailPage(docId){
    this.route.navigateByUrl('tourpackage/details/'+docId);
  };

}